import { db, oid } from '../firebase';

export const getCompanyInfo = () =>
  db.ref(`appData/${oid}/companyInfo`);



// WEBPACK FOOTER //
// ./src/firebase/database/companyInfo.js